export default {"src":"/_next/static/media/standard-logo.654852e3.svg","height":24,"width":95,"blurWidth":0,"blurHeight":0};